//@flow
import React from 'react';

type Props = {
  qty:number,
  inStock:?boolean,
  isAllowed:boolean,
  preSale?:?boolean,
  onClick?:() => void,
};

export default function AddCartSnackCard(props:Props) {
  const buttonText = props.qty ? props.qty : "";
  const className = _getClassName(props);

  return (
    <button onClick={props.onClick} className={className} title="Add to Cart">
      {buttonText}
    </button>
  );
}

AddCartSnackCard.defaultProps = {
  isAllowed: true,
};

function _getClassName(props) {
  const itemsClass = props.qty ? "has-items" : "no-items";
  const stockClass = props.inStock ? "" : "out-of-stock";
  const allowedClass = props.isAllowed ? "" : "not-allowed";
  const preSaleClass = !props.preSale ? "" : "pre-sale";

  return `detail-add ${itemsClass} ${preSaleClass} ${stockClass} ${allowedClass}`;
}
